import React, { Component } from 'react'
import { Button, Checkbox, Icon } from 'antd'
import LangContext from 'modules/shared/context/langContext'

const checkboxRowStyle = {
  display: 'block',
  textAlign: 'left',
  margin: '2px 0',
}

class SafetyFilterPanel extends Component {
  state = { visible: false }

  toggle = () => this.setState(prev => ({ visible: !prev.visible }))

  render() {
    const { visible } = this.state
    const { onFilterChange } = this.props

    return (
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <LangContext.Consumer>
          {i18n => (
            <Button
              onClick={this.toggle}
              type={visible ? 'primary' : 'default'}
            >
              {i18n.n.notificationTypeEvent}{' '}
              <Icon
                type={visible ? 'up' : 'down'}
                style={{ fontSize: '10px' }}
              />
            </Button>
          )}
        </LangContext.Consumer>
        {visible && (
          <div
            style={{
              position: 'absolute',
              top: '34px',
              right: 0,
              zIndex: 100,
              background: 'rgba(255,255,255,0.95)',
              borderRadius: '4px',
              padding: '8px 12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              minWidth: '250px',
            }}
          >
            <div style={checkboxRowStyle}>
              <Checkbox
                onChange={e =>
                  onFilterChange('isParkingSideRoadCheck', e.target.checked)
                }
                className="safety-checkbox-text"
                defaultChecked={true}
              >
                <span className="regular-bold-14">
                  <LangContext.Consumer>
                    {i18n => i18n.p.parkingOnRoadSide}
                  </LangContext.Consumer>
                </span>
              </Checkbox>
            </div>
            <div style={checkboxRowStyle}>
              <Checkbox
                onChange={e =>
                  onFilterChange('isSpeedOverCheck', e.target.checked)
                }
                className="safety-checkbox-text"
                defaultChecked={true}
              >
                <span className="regular-bold-14">
                  <LangContext.Consumer>
                    {i18n => i18n.s.speedOverLimit}
                  </LangContext.Consumer>
                </span>
              </Checkbox>
            </div>
            <div style={checkboxRowStyle}>
              <Checkbox
                onChange={e =>
                  onFilterChange('isDrivingMoreThan4Check', e.target.checked)
                }
                className="safety-checkbox-text"
                defaultChecked={true}
              >
                <span className="regular-bold-14">
                  <LangContext.Consumer>
                    {i18n => i18n.d.driveContinuouslyForMoreThan4Hours}
                  </LangContext.Consumer>
                </span>
              </Checkbox>
            </div>
            <div style={checkboxRowStyle}>
              <Checkbox
                onChange={e =>
                  onFilterChange('isDrivingMoreThan10Check', e.target.checked)
                }
                className="safety-checkbox-text"
                defaultChecked={true}
              >
                <span className="regular-bold-14">
                  <LangContext.Consumer>
                    {i18n => i18n.d.driveContinuouslyForMoreThan10HoursDay}
                  </LangContext.Consumer>
                </span>
              </Checkbox>
            </div>
            <div style={checkboxRowStyle}>
              <Checkbox
                onChange={e =>
                  onFilterChange(
                    'isAggressiveAccelerationAndImmediatelyBreakCheck',
                    e.target.checked,
                  )
                }
                className="safety-checkbox-text"
                defaultChecked={true}
              >
                <span className="regular-bold-14">
                  <LangContext.Consumer>
                    {i18n => i18n.a.aggressiveAccelerationAndImmediatelyBreak}
                  </LangContext.Consumer>
                </span>
              </Checkbox>
            </div>
            <div style={checkboxRowStyle}>
              <Checkbox
                onChange={e =>
                  onFilterChange('isAdasDmsCheck', e.target.checked)
                }
                className="safety-checkbox-text"
                defaultChecked={true}
              >
                <span className="regular-bold-14">
                  <LangContext.Consumer>
                    {i18n => i18n.a.adasDmsEvent}
                  </LangContext.Consumer>
                </span>
              </Checkbox>
            </div>
            <div style={checkboxRowStyle}>
              <Checkbox
                onChange={e =>
                  onFilterChange('isAiCameraCheck', e.target.checked)
                }
                className="safety-checkbox-text"
                defaultChecked={true}
              >
                <span className="regular-bold-14">
                  <LangContext.Consumer>
                    {i18n => i18n.a.aiCameraEvent}
                  </LangContext.Consumer>
                </span>
              </Checkbox>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default SafetyFilterPanel
